import axios from '@/http/axios/index.js'


export default {
    getDepartaments() {
        return axios.get('po/catalog/departaments')
    },
    getClients() {
        return axios.get('po/catalog/clients')
    },
    getVendors() {
        return axios.get('po/catalog/vendors')
    },
    getCategories() {
        return axios.get('po/catalog/categories')
    },
    list(data) {
        return axios.get('po/list', { params: data })
    },
    store(data) {
        return axios.post('po/store', data)
    },
    getFiles(id) {
        return axios.get('po/file/' + id)
    },
    vendorSearch(data) {
        return axios.get('vendors/search', { params: data })
    },
}